<template>
  <div class="video-list-item">
    <div class="video-list-box">
      <div class="list-cover">
        <img :src="$.handleAssetsUrl(item.cover)">
      </div>
      <div class="list-mask"></div>
      <div
        class="list-btn-play"
        @click="play(item)"
      >
        <iconfont
          name="#icon11-11zantingbofanganniu"
          font-size="12px"
          color="#3058FE"
        ></iconfont>
      </div>
      <div
        class="list-btn-del"
        @click="deleteItem"
      >
        <iconfont
          class="normal"
          name="#icon12-12shanchu"
          font-size="12px"
        ></iconfont>
        <iconfont
          class="hover"
          name="#icon12-12shanchujiaohu"
          font-size="12px"
        ></iconfont>
      </div>
      <div class="list-video-duration">
        {{ item.duration | formatTime }}
      </div>
    </div>
    <div class="list-video-name">
      <textShowTip
        :text="item.name"
        :css-object="{ padding: '0 6px' }"
      ></textShowTip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoListItem',
  components: {
    TextShowTip: () => import('@/components/common/textShowTip')
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function() {
        return { src: '', name: '', duration: 0 };
      }
    },
    index: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      showTips: false
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   if(this.$refs.listName.scrollWidth > this.$refs.listName.clientWidth) {
    //     this.showTips = true;
    //   }
    // });
  },
  methods: {
    play() {
      this.$modal.show('videoPlayModal', this.item);
    },
    deleteItem() {
      this.$emit('delClick', this.index);
    }
  }
};
</script>
<style lang="scss" scoped>
.video-list-item {
  position: relative;
  width: 260px;
  height: 147px;
  background-color: #fff;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  user-select: none;
}
.video-list-box {
  width: 100%;
  height: 100%;

  &:hover {
    .list-btn-play,
    .list-btn-del {
      opacity: 1;
    }
    .list-mask {
      display: block;
    }
  }
}
.list-cover {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: #f2f4f8;
  overflow: hidden;
  > img {
    max-height: 100%;
    max-width: 100%;
  }
}
.list-mask {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
}
.list-btn-play {
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  position: absolute;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8);
  transition: opacity 0.3s;
  cursor: pointer;
}
.list-btn-del {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 18px;
  top: 18px;
  opacity: 0;
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  transform: translate(9px, -12px);
  transition: all 0.3s;
  cursor: pointer;

  .hover {
    display: none;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 1);

    .normal {
      display: none;
    }
    .hover {
      display: block;
    }
  }
}
.list-video-duration {
  position: absolute;
  right: 9px;
  bottom: 9px;
  width: 50px;
  height: 21px;
  color: #fff;
  background: #000000;
  opacity: 0.6;
  border-radius: 4px;
  line-height: 21px;
}
.list-video-name {
  position: absolute;
  bottom: -25px;
  left: 0;
  width: 100%;
}
</style>
